export default __webpack_public_path__ + "static/9-098e878ec0dad4a528962f460badf76a.jpg";